"use client";

import { useEffect, useState } from "react";
import {
  getLocalCartItems,
  LOCAL_CART_UPDATED_EVENT,
  type LocalCartItem,
} from "@/lib/local-cart";

export function useLocalCart() {
  const [items, setItems] = useState<LocalCartItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;

    const refresh = async () => {
      try {
        const storedItems = await getLocalCartItems();
        if (active) {
          setItems(storedItems);
          setError("");
        }
      } catch (loadError) {
        if (active) {
          console.error("Could not load the local cart.", loadError);
          setError(
            loadError instanceof Error
              ? loadError.message
              : "No se pudo cargar el carrito de este navegador.",
          );
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    void refresh();
    window.addEventListener(LOCAL_CART_UPDATED_EVENT, refresh);
    window.addEventListener("focus", refresh);
    return () => {
      active = false;
      window.removeEventListener(LOCAL_CART_UPDATED_EVENT, refresh);
      window.removeEventListener("focus", refresh);
    };
  }, []);

  return { items, loading, error };
}
